// New: UI_REVAMP

import { create } from 'zustand';

export const useBet3Store = create((set) => ({
	slots: [],
	setSlots: (slots) => set({ slots }),
	updateSlot: (index, value) =>
		set((state) => {
			const newSlots = [...state.slots];
			newSlots[index] = value;
			return { slots: newSlots };
		}),
	clearSlots: (slotCount) => set({ slots: new Array(slotCount).fill('') }),
}));
